import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import AnimatedButton from "@components/WebsiteRevamp/AnimatedButton/AnimatedButton"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	BackendButton,
	HeroModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import clsx from "clsx"
import {AnimatePresence, motion} from "framer-motion"
import React from "react"

import styles from "./HomeHeroAnimated.module.scss"
import LaptopScreen from "./LaptopScreen"
import LogoSvgPositioned from "./LogoSvgPositioned"

interface HeroSlideContentProps {
	heroItem: HeroModuleType
	textColor: "black" | "white"
	titleStyle?: string
	backgroundColor: string
	currentIndex: number
}

const HeroSlideContent: React.FC<HeroSlideContentProps> = ({
	heroItem,
	textColor,
	titleStyle = "",
	backgroundColor,
	currentIndex,
}) => {
	return (
		<>
			<motion.div
				style={{
					position: "relative",
					borderRadius: "25px",
					// overflow: "hidden",
				}}
				initial={false}
				animate={{backgroundColor}}
				transition={{duration: 0.6, ease: "easeInOut"}}
			>
				<div
					className={styles.contentBox}
					style={{position: "relative", zIndex: 5}}
				>
					<div
						className={styles.contentWrapper}
						style={{color: textColor}}
					>
						<div className={styles.titleContainer}>
							<div className={styles.titleBox}>
								<AnimatePresence
									mode={"popLayout"}
									// keyId={`${heroItem.beforeTitlesIcon?.src}${heroItem.title}`}
								>
									<motion.div
										key={currentIndex}
										initial={{opacity: 0}}
										animate={{opacity: 1}}
										exit={{opacity: 0}}
										transition={{
											duration: 0.4,
											ease: "easeInOut",
										}}
									>
										<div
											className={styles.contentBoxInside}
										>
											<NewResponsiveImage
												{...heroItem.mobileAsset}
												src={
													heroItem.mobileAsset?.src ??
													""
												}
												alt={heroItem.title}
												containerClassName={clsx(
													styles.mobilePictureContainer,
												)}
												imageClassName={clsx(
													styles.mobilePicture,
												)}
											/>
											<NewResponsiveImage
												{...heroItem.beforeTitlesIcon}
												src={
													heroItem.beforeTitlesIcon
														?.src ?? ""
												}
												alt={heroItem.title}
												containerClassName={clsx(
													styles.IconImageContainer,
												)}
												imageClassName={clsx(
													styles.IconImage,
												)}
											/>
											<Typography
												as={
													currentIndex === 0
														? "h1"
														: "h2"
												}
												className={clsx(
													styles.title,
													titleStyle,
													styles.titleStyle,
													currentIndex === 0 &&
														styles.first,
												)}
												content={heroItem.title}
												fontWeight={200}
												stripHtml={false}
												size={Size.XXL}
												style={{
													// maxWidth: "595px",
													lineHeight: "3.75rem",
												}}
												variant={Variant.Title}
												contrast={currentIndex !== 0}
												noPadding
											/>
										</div>
									</motion.div>
								</AnimatePresence>
								{heroItem?.buttons &&
									heroItem?.buttons?.length > 0 && (
										<>
											<div
												className={
													styles.ButtonContainer
												}
											>
												{heroItem.buttons.map(
													(
														btn: BackendButton,
														index: number,
													) => (
														<AnimatedButton
															key={index}
															text={btn.text}
															href={btn.link}
															// @ts-expect-error
															variant={
																btn.buttonType
															}
															disablePaddingHorizontalClass={
																btn.buttonType ===
																"text"
																	? styles.disablePaddingHorizontalClass
																	: ""
															}
															theme={
																currentIndex ===
																0
																	? "oneHome"
																	: currentIndex ===
																	  1
																	? "oneDefault"
																	: "studio"
															}
															contrast={
																currentIndex ===
																0
																	? "light"
																	: currentIndex ===
																			2 &&
																	  index ===
																			0
																	? "light"
																	: "dark"
															}
														/>
													),
												)}
											</div>
										</>
									)}
							</div>
						</div>
					</div>
				</div>
				<LaptopScreen imageSrc={heroItem.desktopAsset?.src} />
				<LogoSvgPositioned slideIndex={currentIndex} />
			</motion.div>
		</>
	)
}

export default HeroSlideContent
